import { render, staticRenderFns } from "./CompactPriceSelector.vue?vue&type=template&id=5d801344&"
import script from "./CompactPriceSelector.vue?vue&type=script&lang=js&"
export * from "./CompactPriceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports